// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__aVbdo","buttonWrapper":"Hero_buttonWrapper__AxUYV"};